import React from "react";
import Premiums from "components/organisms/AddPremiumsSteps/Premiums";

export const premiumSteps = [
  {
    title: "Premiums",
    content: <Premiums />,
  }
];
